export const calculatePercentDone = (current, total) => {
    if (total === 0n) {
        return 100;
    }
    // Ensure it doesn't exceed 100%
    if (current > total) {
        current = total;
    }
    return Number((current * 100n) / total);
};
